import { useAppSelector, useAppDispatch } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
// import { useWebSocket } from "@request/context";
import { useCallback } from "react";
import { getMerchantBalances } from "./slice";

export const useMerchantBalance = (/* updateBalance: boolean = true */) => {
  const userId = useUserId();
  // const { subscribeToTopic, unsubscribeFromTopic, connected } = useWebSocket();
  const state = useAppSelector((state) => state.merchantBalance);

  const dispatch = useAppDispatch();

  const getMerchantBalancesHandler = useCallback(
    () => dispatch(getMerchantBalances(userId)),
    [dispatch, userId]
  );

  // useEffect(() => {
  //   if (updateBalance) getMerchantBalancesHandler();

  //   const interval = setInterval(() => {
  //     if (updateBalance) getMerchantBalancesHandler();
  //   }, 60000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [getMerchantBalancesHandler, updateBalance]);

  return {
    state,
    getBalances: getMerchantBalancesHandler,
  };

  // useEffect(() => {
  //     if (connected) {
  //         subscribeToTopic(
  //             "/topic/balances",
  //             "balances",
  //             (message: BalanceServerData) => {
  //                 setBalance(message);
  //             }
  //         );
  //         return () => {
  //             unsubscribeFromTopic("balances");
  //         };
  //     }
  // }, [connected, subscribeToTopic, unsubscribeFromTopic]);
};
